var _ = { escape: require('lodash.escape') };
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<script nonce="{{ csp_nonce() }}" type="text/javascript">function showPicker() {\n        if ("showPicker" in HTMLSelectElement.prototype) {\n            document.querySelector("#reason_select").showPicker();\n        }\n    }</script><div onclick="showPicker()" style="display: flex; justify-content: center; align-items: center;"><div style="opacity: 0.3; position: relative;"><div style="pointer-events: none;"><ul class="profile-cal__time-listing"><li class="profile-cal__time-item">08:00</li><li class="profile-cal__time-item">08:30</li><li class="profile-cal__time-item">09:00</li><li class="profile-cal__time-item">09:30</li><li class="profile-cal__time-item">10:00</li><li class="profile-cal__time-item">10:30</li><li class="profile-cal__time-item">11:00</li><li class="profile-cal__time-item">11:30</li><li class="profile-cal__time-item">12:00</li></ul><ul class="profile-cal__time-listing"><li class="profile-cal__time-item">08:00</li><li class="profile-cal__time-item">08:30</li><li class="profile-cal__time-item">09:00</li><li class="profile-cal__time-item">09:30</li><li class="profile-cal__time-item">10:00</li><li class="profile-cal__time-item">10:30</li><li class="profile-cal__time-item">11:00</li><li class="profile-cal__time-item">11:30</li><li class="profile-cal__time-item">12:00</li></ul><ul class="profile-cal__time-listing"><li class="profile-cal__time-item">08:00</li><li class="profile-cal__time-item">08:30</li><li class="profile-cal__time-item">09:00</li><li class="profile-cal__time-item">09:30</li><li class="profile-cal__time-item">10:00</li><li class="profile-cal__time-item">10:30</li><li class="profile-cal__time-item">11:00</li><li class="profile-cal__time-item">11:30</li><li class="profile-cal__time-item">12:00</li></ul><ul class="profile-cal__time-listing"><li class="profile-cal__time-item">08:00</li><li class="profile-cal__time-item">08:30</li><li class="profile-cal__time-item">09:00</li><li class="profile-cal__time-item">09:30</li><li class="profile-cal__time-item">10:00</li><li class="profile-cal__time-item">10:30</li><li class="profile-cal__time-item">11:00</li><li class="profile-cal__time-item">11:30</li><li class="profile-cal__time-item">12:00</li></ul><ul class="profile-cal__time-listing"><li class="profile-cal__time-item">08:00</li><li class="profile-cal__time-item">08:30</li><li class="profile-cal__time-item">09:00</li><li class="profile-cal__time-item">09:30</li><li class="profile-cal__time-item">10:00</li><li class="profile-cal__time-item">10:30</li><li class="profile-cal__time-item">11:00</li><li class="profile-cal__time-item">11:30</li><li class="profile-cal__time-item">12:00</li></ul><ul class="profile-cal__time-listing"><li class="profile-cal__time-item">08:00</li><li class="profile-cal__time-item">08:30</li><li class="profile-cal__time-item">09:00</li><li class="profile-cal__time-item">09:30</li><li class="profile-cal__time-item">10:00</li><li class="profile-cal__time-item">10:30</li><li class="profile-cal__time-item">11:00</li><li class="profile-cal__time-item">11:30</li><li class="profile-cal__time-item">12:00</li></ul><ul class="profile-cal__time-listing"><li class="profile-cal__time-item">08:00</li><li class="profile-cal__time-item">08:30</li><li class="profile-cal__time-item">09:00</li><li class="profile-cal__time-item">09:30</li><li class="profile-cal__time-item">10:00</li><li class="profile-cal__time-item">10:30</li><li class="profile-cal__time-item">11:00</li><li class="profile-cal__time-item">11:30</li><li class="profile-cal__time-item">12:00</li></ul></div></div><div style="position: absolute; background: #c3c3c3; color: black; padding: 40px; opacity: .7; border: 1px solid black;"><div style="text-align: center; max-width: 200px;"><span style="color: black; font-size: 30px;">Choose ' +
__e( reasonLabel ) +
' First</span></div></div></div>';

}
return __p
};

/*
original source:

<script nonce="{{ csp_nonce() }}" type="text/javascript">
    function showPicker() {
        if ("showPicker" in HTMLSelectElement.prototype) {
            document.querySelector("#reason_select").showPicker();
        }
    }
</script>

<div onclick="showPicker()" style="display: flex; justify-content: center; align-items: center;">
    <div style="opacity: 0.3; position: relative;">
        <div style="pointer-events: none;">
        <ul class="profile-cal__time-listing">
            <li class="profile-cal__time-item">08:00</li>
            <li class="profile-cal__time-item">08:30</li>
            <li class="profile-cal__time-item">09:00</li>
            <li class="profile-cal__time-item">09:30</li>
            <li class="profile-cal__time-item">10:00</li>
            <li class="profile-cal__time-item">10:30</li>
            <li class="profile-cal__time-item">11:00</li>
            <li class="profile-cal__time-item">11:30</li>
            <li class="profile-cal__time-item">12:00</li>
        </ul>
        <ul class="profile-cal__time-listing">
            <li class="profile-cal__time-item">08:00</li>
            <li class="profile-cal__time-item">08:30</li>
            <li class="profile-cal__time-item">09:00</li>
            <li class="profile-cal__time-item">09:30</li>
            <li class="profile-cal__time-item">10:00</li>
            <li class="profile-cal__time-item">10:30</li>
            <li class="profile-cal__time-item">11:00</li>
            <li class="profile-cal__time-item">11:30</li>
            <li class="profile-cal__time-item">12:00</li>
        </ul>
        <ul class="profile-cal__time-listing">
            <li class="profile-cal__time-item">08:00</li>
            <li class="profile-cal__time-item">08:30</li>
            <li class="profile-cal__time-item">09:00</li>
            <li class="profile-cal__time-item">09:30</li>
            <li class="profile-cal__time-item">10:00</li>
            <li class="profile-cal__time-item">10:30</li>
            <li class="profile-cal__time-item">11:00</li>
            <li class="profile-cal__time-item">11:30</li>
            <li class="profile-cal__time-item">12:00</li>
        </ul>
        <ul class="profile-cal__time-listing">
            <li class="profile-cal__time-item">08:00</li>
            <li class="profile-cal__time-item">08:30</li>
            <li class="profile-cal__time-item">09:00</li>
            <li class="profile-cal__time-item">09:30</li>
            <li class="profile-cal__time-item">10:00</li>
            <li class="profile-cal__time-item">10:30</li>
            <li class="profile-cal__time-item">11:00</li>
            <li class="profile-cal__time-item">11:30</li>
            <li class="profile-cal__time-item">12:00</li>
        </ul>
        <ul class="profile-cal__time-listing">
            <li class="profile-cal__time-item">08:00</li>
            <li class="profile-cal__time-item">08:30</li>
            <li class="profile-cal__time-item">09:00</li>
            <li class="profile-cal__time-item">09:30</li>
            <li class="profile-cal__time-item">10:00</li>
            <li class="profile-cal__time-item">10:30</li>
            <li class="profile-cal__time-item">11:00</li>
            <li class="profile-cal__time-item">11:30</li>
            <li class="profile-cal__time-item">12:00</li>
        </ul>
        <ul class="profile-cal__time-listing">
            <li class="profile-cal__time-item">08:00</li>
            <li class="profile-cal__time-item">08:30</li>
            <li class="profile-cal__time-item">09:00</li>
            <li class="profile-cal__time-item">09:30</li>
            <li class="profile-cal__time-item">10:00</li>
            <li class="profile-cal__time-item">10:30</li>
            <li class="profile-cal__time-item">11:00</li>
            <li class="profile-cal__time-item">11:30</li>
            <li class="profile-cal__time-item">12:00</li>
        </ul>
        <ul class="profile-cal__time-listing">
            <li class="profile-cal__time-item">08:00</li>
            <li class="profile-cal__time-item">08:30</li>
            <li class="profile-cal__time-item">09:00</li>
            <li class="profile-cal__time-item">09:30</li>
            <li class="profile-cal__time-item">10:00</li>
            <li class="profile-cal__time-item">10:30</li>
            <li class="profile-cal__time-item">11:00</li>
            <li class="profile-cal__time-item">11:30</li>
            <li class="profile-cal__time-item">12:00</li>
        </ul>
        </div>
    </div>
    <div style="position: absolute; background: #c3c3c3; color: black; padding: 40px; opacity: .7; border: 1px solid black;">
        <div style="text-align: center; max-width: 200px;">
            <span style="color: black; font-size: 30px;">Choose <%- reasonLabel %> First</span>
        </div>
    </div>
</div>

*/
